import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import BackgroundImageBlue from '../../../assets/images/background_blue.jpg';

export const Wrapper = styled.div`
    width: 100%;
    margin: auto;

    position: sticky;
    top: 0;
    left: 0;
    z-index: 4;

    display: flex;
    flex-direction: column-reverse;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    background-image: url(${BackgroundImageBlue});
    background-repeat: no-repeat;
    background-size: 100vw 100vh;
    background-position: 0 0;
    background-attachment: fixed;
    background-color: #090719;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        height: 97px;
        flex-direction: row;
        justify-content: space-between;
        align-items: stretch;
        gap: 50px;

        top: 75px;
    }
`;

export const HeaderNavButton = styled.div<{ $isActive?: boolean }>`
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    opacity: 0.5;
    transition: all 0.2s ease;
    user-select: none;

    font-weight: 700;
    line-height: 100%;
    color: #ffffff;
    font-size: 14px;

    ${({ $isActive }) =>
        $isActive &&
        css`
            opacity: 1;
        `};

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 0;
        overflow: unset;
        width: auto;
        height: auto;
        max-width: unset;
        font-size: 18px;
        max-width: 128px;
    }
`;

export const ButtonWrapper = styled.div`
    display: inline-flex;
    gap: 20px;
    position: relative;

    width: 100%;
    height: 43px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        overflow: unset;
        width: auto;
        height: auto;
        gap: 40px;
    }
`;

export const StatItem = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 20px 0;
    }
`;

export const StatHeading = styled(motion.div)`
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: -1.5px;
    display: flex;
    align-items: flex-end;
    > span {
        font-size: 14px;
        line-height: 100%;
        margin-right: 5px;
        margin-left: 1px;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 24px;
    }
`;

export const StatsWrapper = styled(motion.div)<{ $isLoading?: boolean }>`
    display: inline-flex;
    align-items: center;
    gap: 20px;
    padding: 0 20px;
    width: 100%;

    overflow: hidden;
    overflow-x: auto;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 0;
        overflow: unset;
        width: auto;
        gap: 40px;
    }

    ${({ $isLoading }) =>
        $isLoading &&
        css`
            ${StatHeading} {
                opacity: 0.5;
                background: grey;
                min-width: 60px;
                min-height: 20px;
                margin-top: 5px;
                border-radius: 8px;
            }
        `}
`;

export const StatLabel = styled.div`
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    display: flex;
    align-items: center;
    letter-spacing: -0.03em;
    color: rgba(255, 255, 255, 0.5);
`;

export const Separator = styled.div`
    height: 20px;
    width: 1px;
    background-color: rgba(255, 255, 255, 0.15);
    position: relative;
    top: -10px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        height: 40px;
        top: unset;
    }
`;

export const ActiveLine = styled(motion.div)`
    pointer-events: none;
    content: '';
    display: block;
    width: 89px;
    height: 2px;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: #fff;
`;
